import { Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { InfoOutlined } from "@mui/icons-material";
import moment from "moment";
import { Dispatch, FC, SetStateAction, useEffect, useRef, useState } from "react";
import { Subscription } from "types/summary";
import { currencyFormatter, transformForcastValue } from "utils";

const useStyles = makeStyles(() => ({
  revenueContainer: {
    // background: "#fff",
    // padding: 16,
    // borderRadius: 4,
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: 40,
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
    // marginLeft: 16,
    display: "flex",
  },
  tableContainer: {
    // marginTop: 10,
    margin: "10px 0 0 40px",
  },
  tabs: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  space: {
    margin: "0 5px 0 5px",
  },
  table: {
    minWidth: 1583,
    // width: "80vw",
    // width: 1553,
    overflow: "auto",
    textAlign: "center",
    // border: "2px solid #C0C0C0",
    borderTop: "none",
    borderLeft: "none",
    borderCollapse: "collapse",
    tableLayout: "fixed",
  },
  thead: {
    position: "sticky",
    top: 0,
    background: "#f7f7f7",
    borderBottom: "2px solid #C0C0C0",
  },
  commonThead: {
    // width: "9%",
    borderRight: "1px solid #C0C0C0",
    borderBottom: "1px solid #C0C0C0",
    // padding: 5,
    textAlign: "center",
    verticalAlign: "middle",
    lineHeight: "36px",
    boxSizing: "border-box",
    fontWeight: "bold",
    "&:last-child": {
      borderRight: "none",
    },
  },
  tbody: {
    // border: "1px solid #C0C0C0",
    borderCollapse: "collapse",
  },
  row: {
    borderBottom: "1px solid #C0C0C0",
    verticalAlign: "top",
  },
  commonTd: {
    borderRight: "1px solid #C0C0C0",
    // padding: 5,
    textAlign: "center",
    // lineHeight: "20px",
    // whiteSpace: "nowrap",
    verticalAlign: "middle",
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    boxSizing: "border-box",
    borderBottom: "1px solid #C0C0C0",
    "&:last-child": {
      borderRight: "none",
      borderBottom: "none",
    },
  },
  bookingTd: {
    width: "21%",
  },
  labelTd: {
    width: "4%",
  },
  subDate: {
    width: "7%",
  },
  numTd: {
    width: "7%",
  },
  horizontalBorder: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    borderBottom: "1px solid #C0C0C0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  amountWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "0 5px",
  },
}));

const CustomerRevenueProfile: FC<{
  data: any;
  selectedData: any;
  active: string;
  setActive: Dispatch<SetStateAction<string>>;
}> = ({ data, selectedData, active, setActive }) => {
  const [width, setWidth] = useState(1583);
  // const width = 1553;
  const revenueTable = useRef<HTMLTableElement>(null);
  const classes = useStyles({ width });
  const [applyData, setApplyData] = useState<any>([data?.accounts?.[0]]);

  useEffect(() => {
    const tableWidth = revenueTable?.current?.clientWidth;
    setWidth(tableWidth as number);
  }, [data, width]);

  useEffect(() => {
    const parent = revenueTable.current?.parentElement;
    if (!parent) return;

    const observer = new ResizeObserver(() => {
      setWidth(revenueTable.current?.clientWidth || 1583);
    });
    observer.observe(parent);

    return () => observer.disconnect();
  }, [revenueTable]);

  useEffect(() => {
    setActive("sub");
    // setApplyData([data?.accounts?.[0]]);
    const curAccountKey = data?.accounts?.[0]?.accountKey;
    data?.subscriptions
      .filter((s: Subscription) => s.accountKey === curAccountKey)
      .map((sub: any) => {
        sub.csmName = data?.accounts?.[0]?.csmInfo?.name;
      });
    setApplyData(data?.subscriptions.filter((s: Subscription) => s.accountKey === curAccountKey));
  }, [data, selectedData]);

  const switchTab = (type: string) => () => {
    setActive(type);
    if (type === "sub") {
      // flat account into subscription
      // find subscription & account have same accountKey
      // add csm name into subscription
      const curAccountKey = data?.accounts?.[0]?.accountKey;
      data?.subscriptions
        .filter((s: Subscription) => s.accountKey === curAccountKey)
        .map((sub: any) => {
          sub.csmName = data?.accounts?.[0]?.ciscoCsmName;
        });
      setApplyData(data?.subscriptions.filter((s: Subscription) => s.accountKey === curAccountKey));
    } else {
      data?.subscriptions?.map((a: any) => {
        const csmName = data?.accounts.filter((i: any) => i.accountKey === a.accountKey);
        a.csmName = csmName?.[0]?.ciscoCsmName;
      });
      setApplyData(data?.subscriptions);
    }
  };

  const handleAmount = (data: number) => {
    if (data) {
      return currencyFormatter(data)?.slice(1);
    } else {
      return "-";
    }
  };

  return (
    <div className={classes.revenueContainer}>
      <div className={classes.titleContainer}>
        <p className={classes.title}>
          Customer Revenue Profile{" "}
          <Tooltip title="The customer revenue and renewal date by account(s), subscription(s) and workload(s).">
            <InfoOutlined
              fontSize="small"
              htmlColor="#656565"
              style={{ marginLeft: 5 }}
            />
          </Tooltip>
        </p>
      </div>
      <div className={classes.tableContainer}>
        <div className={classes.tabs}>
          <p
            onClick={switchTab("sub")}
            style={{
              color: active === "sub" ? "#0A84FF" : "#333",
              fontWeight: active === "sub" ? "bold" : "normal",
            }}
          >
            Subscription
          </p>
          <p className={classes.space}>||</p>
          <p
            onClick={switchTab("all")}
            style={{
              color: active === "all" ? "#0A84FF" : "#333",
              fontWeight: active === "all" ? "bold" : "normal",
            }}
          >
            All Selected Accounts
          </p>
        </div>
        <div
          style={{
            // width: 1480,
            maxWidth: "100%",
            maxHeight: "60vh",
            overflowY: "auto",
            overflowX: "auto",
            border: "2px solid #C0C0C0",
          }}
        >
          <table
            className={classes.table}
            ref={revenueTable}
          >
            <thead className={classes.thead}>
              <tr>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Account ID
                </td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Collab CSM
                </td>
                <td
                  className={`${classes.commonThead} ${classes.bookingTd}`}
                  style={
                    {
                      // verticalAlign: "middle",
                    }
                  }
                >
                  Device Booking3Y
                  <table
                    style={{
                      width: "100%",
                      borderTop: "1px solid #C0C0C0",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          className={`${classes.commonThead}`}
                          style={{
                            width: "25%",
                            borderRight: "1px solid #C0C0C0",
                            borderBottom: "none",
                          }}
                        >
                          Video Cloud
                        </td>
                        <td
                          className={`${classes.commonThead}`}
                          style={{ width: "25%", borderBottom: "none" }}
                        >
                          Video Not On Cloud
                        </td>
                        <td
                          className={`${classes.commonThead}`}
                          style={{ width: "25%", borderBottom: "none" }}
                        >
                          Phone
                        </td>
                        <td
                          className={`${classes.commonThead}`}
                          style={{ width: "25%", borderBottom: "none" }}
                        >
                          Peripherals
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td
                  className={`${classes.commonThead} ${classes.subDate}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Subscription
                </td>
                <td
                  className={`${classes.commonThead} ${classes.subDate}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Renewal Date
                </td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Renewal Forecasting
                </td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Subscription Risk Assessment
                </td>
                <td
                  className={`${classes.commonThead} ${classes.labelTd}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                ></td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Suite
                </td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Meetings and Messaging
                </td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Calling
                </td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  Contact Center
                </td>
                <td
                  className={`${classes.commonThead}`}
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  CPAAS
                </td>
              </tr>
            </thead>
            <tbody className={classes.tbody}>
              {applyData?.map((sub: any, idx: number) => (
                <tr
                  key={sub?.subscriptionKey ?? `${sub?.accountKey ?? "acct"}-${idx}`}
                  className={classes.row}
                >
                  {sub?.accountKey === applyData?.[idx - 1]?.accountKey ? null : (
                    <td
                      rowSpan={
                        applyData.filter((a: any) => a?.accountKey === sub?.accountKey)?.length ?? 1
                      }
                      className={`${classes.commonTd} ${classes.numTd}`}
                    >
                      {sub.accountId}
                    </td>
                  )}
                  {sub?.accountKey === applyData?.[idx - 1]?.accountKey ? null : (
                    <Tooltip
                      title={sub?.csmName ?? ""}
                      key={`csm-${sub?.subscriptionKey ?? idx}`}
                    >
                      <td
                        rowSpan={
                          applyData.filter((a: any) => a?.accountKey === sub?.accountKey)?.length ??
                          1
                        }
                        className={`${classes.commonTd} ${classes.numTd}`}
                        style={{ cursor: "pointer" }}
                      >
                        {sub?.csmName ?? "N/A"}
                      </td>
                    </Tooltip>
                  )}
                  {sub?.accountKey === applyData?.[idx - 1]?.accountKey ? null : (
                    <td
                      className={`${classes.commonTd}`}
                      style={{
                        height: applyData.filter((a: any) => a?.accountKey === sub?.accountKey)
                          ?.length
                          ? applyData.filter((a: any) => a?.accountKey === sub?.accountKey)
                              ?.length * 37.31
                          : 37.31,
                      }}
                      rowSpan={
                        applyData.filter((a: any) => a?.accountKey === sub?.accountKey)?.length ?? 1
                      }
                    >
                      <table
                        style={{
                          width: "100%",
                          height: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody>
                          <tr
                            style={{
                              display: "flex",
                              height: "100%",
                            }}
                          >
                            <td
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "25%",
                                borderRight: "1px solid #C0C0C0",
                                padding: "0 5px",
                              }}
                            >
                              <span>$</span>
                              <span>
                                {handleAmount(sub?.arrMrrBundleSummary?.videoDeviceCloudAmount3Y)}
                              </span>
                            </td>
                            <td
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "25%",
                                borderRight: "1px solid #C0C0C0",
                                padding: "0 5px",
                              }}
                            >
                              <span>$</span>
                              <span>
                                {handleAmount(
                                  sub?.arrMrrBundleSummary?.videoDeviceNonCloudAmount3Y
                                )}
                              </span>
                            </td>
                            <td
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "25%",
                                borderRight: "1px solid #C0C0C0",
                                padding: "0 5px",
                              }}
                            >
                              <span>$</span>
                              <span>{handleAmount(sub?.arrMrrBundleSummary?.phoneAmount3Y)}</span>
                            </td>
                            <td
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "25%",
                                padding: "0 5px",
                              }}
                            >
                              <span>$</span>
                              <span>
                                {handleAmount(sub?.arrMrrBundleSummary?.peripheralsAmount3Y)}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  )}

                  <td className={`${classes.commonTd} ${classes.subDate}`}>
                    {sub?.subscriptionId ?? "N/A"}
                  </td>
                  <td className={`${classes.commonTd} ${classes.subDate}`}>
                    {sub?.renewalDate ? moment(sub?.renewalDate).format("MM/DD/YYYY") : "N/A"}
                  </td>
                  <td className={` ${classes.commonTd} ${classes.numTd}`}>
                    {sub?.assessment?.forecasting
                      ? transformForcastValue(sub?.assessment?.forecasting)
                      : "N/A"}
                  </td>
                  <td className={` ${classes.commonTd} ${classes.numTd}`}>
                    {sub?.assessment?.subRiskAssessment ?? "N/A"}
                  </td>
                  <td className={`${classes.commonTd} ${classes.labelTd}`}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr
                          className={classes.horizontalBorder}
                          style={{ justifyContent: "left" }}
                        >
                          <td style={{ marginLeft: 5 }}>Cloud</td>
                        </tr>
                        <tr
                          className={classes.horizontalBorder}
                          style={{ justifyContent: "left" }}
                        >
                          <td style={{ marginLeft: 5 }}>On-Prem</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className={`${classes.commonTd} ${classes.numTd}`}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>{handleAmount(sub?.arrMrrBundleSummary?.arrCloudSuite)}</span>
                          </td>
                        </tr>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>{handleAmount(sub?.arrMrrBundleSummary?.arrOnPremSuite)}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className={`${classes.commonTd} ${classes.numTd}`}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>
                              {" "}
                              {handleAmount(sub?.arrMrrBundleSummary?.arrCloudMeetingsMessaging)}
                            </span>
                          </td>
                        </tr>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>
                              {" "}
                              {handleAmount(sub?.arrMrrBundleSummary?.arrOnPremMeetingMessaging)}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className={`${classes.commonTd} ${classes.numTd}`}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>{handleAmount(sub?.arrMrrBundleSummary?.arrCloudCalling)}</span>
                          </td>
                        </tr>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>{handleAmount(sub?.arrMrrBundleSummary?.arrOnPremCalling)}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className={`${classes.commonTd} ${classes.numTd}`}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>
                              {handleAmount(sub?.arrMrrBundleSummary?.arrCloudContactCenter)}
                            </span>
                          </td>
                        </tr>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>
                              {handleAmount(sub?.arrMrrBundleSummary?.arrOnPremContactCenter)}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className={`${classes.commonTd} ${classes.numTd}`}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>{handleAmount(sub?.arrMrrBundleSummary?.arrCloudCPass)}</span>
                          </td>
                        </tr>
                        <tr className={classes.horizontalBorder}>
                          <td className={classes.amountWrapper}>
                            <span>$</span>
                            <span>{handleAmount(0)}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default CustomerRevenueProfile;
